import React from 'react';

// ── Terms of Service Modal ────────────────────────────────────────────────────
// Shown during new-account creation — previously only reachable from the
// phone+SMS-OTP flow, now shown from WhatsAppRegisterPanel's PIN step since
// that's the main registration path.
const TermsModal = ({ onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col" dir="rtl">
      {/* Modal header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
        <div>
          <h2 className="text-base font-bold text-gray-900">شروط الخدمة وسياسة الخصوصية</h2>
          <p className="text-xs text-gray-400 mt-0.5">منصة سافر لحجز تذاكر الباصات · آخر تحديث: 01 مايو 2026</p>
        </div>
        <button onClick={onClose}
          className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 transition-colors text-lg leading-none">
          ×
        </button>
      </div>

      {/* Scrollable content */}
      <div className="overflow-y-auto flex-1 px-6 py-5 space-y-5 text-sm text-gray-700 leading-relaxed">

        <p className="text-gray-500 text-xs border-r-2 border-blue-400 pr-3">
          يرجى قراءة هذه الشروط بعناية. باستخدامك للتطبيق أو إنشاء حساب أو إتمام عملية حجز، فإنك تقر بموافقتك الكاملة على جميع الشروط الواردة أدناه.
        </p>

        {[
          {
            title: 'أولاً: التعريفات',
            items: [
              'التطبيق / المنصة: يقصد به تطبيق أو موقع سافر.',
              'المستخدم / المسافر: أي شخص يستخدم التطبيق للحجز أو الاستفسار أو الدفع.',
              'شركة الباص / الناقل: أي شركة نقل أو باصات تعرض خدماتها عبر التطبيق.',
              'الخدمة: خدمة تسهيل البحث والحجز والدفع الإلكتروني لتذاكر السفر.',
            ],
          },
          {
            title: 'ثانياً: طبيعة الخدمة',
            items: [
              'يعمل التطبيق كمنصة إلكترونية لتسهيل حجز تذاكر السفر فقط.',
              'التطبيق ليس شركة نقل، ولا يملك أو يدير أي باصات أو رحلات.',
              'جميع خدمات النقل يتم تقديمها بواسطة شركات الباصات والناقلين المستقلين.',
              'العلاقة التعاقدية الخاصة بالسفر والنقل تعتبر بين المسافر وشركة الباص مباشرة.',
            ],
          },
          {
            title: 'ثالثاً: موافقة المستخدم',
            items: [
              'صحة البيانات المدخلة أثناء التسجيل أو الحجز.',
              'الالتزام بقوانين وأنظمة السفر المعمول بها داخل السودان.',
              'الالتزام بمواعيد الحضور والانطلاق المحددة بواسطة شركة الباص.',
              'تحمل مسؤولية أي معلومات خاطئة يتم إدخالها أثناء الحجز.',
            ],
          },
          {
            title: 'رابعاً: الحجز والدفع',
            items: [
              'يتم تأكيد الحجز بعد اكتمال عملية الدفع بنجاح.',
              'الأسعار والمواعيد وعدد المقاعد يتم تحديدها بواسطة شركة الباص.',
              'قد تتغير الأسعار أو المواعيد أو الرحلات دون إشعار مسبق من شركة النقل.',
              'التطبيق غير مسؤول عن أي تغيير أو إلغاء أو تأخير في الرحلات.',
            ],
          },
          {
            title: 'خامساً: سياسة الإلغاء والاسترداد',
            items: [
              'تخضع عمليات الإلغاء أو تعديل الحجز أو استرداد المبالغ لسياسات شركة الباص نفسها.',
              'قد يتم خصم رسوم إدارية أو بنكية حسب طريقة الدفع.',
              'التطبيق لا يضمن استرداد أي مبلغ إلا وفق سياسة الناقل.',
            ],
          },
          {
            title: 'سادساً: إخلاء المسؤولية',
            items: [
              'التطبيق مجرد وسيط إلكتروني لتسهيل الحجز فقط.',
              'التطبيق لا يتحمل أي مسؤولية قانونية أو مالية أو تشغيلية تتعلق بخدمة النقل نفسها.',
              'التطبيق غير مسؤول عن: تأخير الرحلات، إلغاء الرحلات، الحوادث أو الإصابات، فقدان أو تلف الأمتعة، سوء الخدمة، تغيير المقاعد أو المسارات، تصرفات موظفي شركة الباص، أي نزاع بين المسافر وشركة النقل.',
              'تقع المسؤولية الكاملة عن تنفيذ الرحلة وجودة الخدمة على شركة الباص أو الناقل.',
              'أي مطالبات أو شكاوى تخص الرحلة يجب توجيهها مباشرة إلى شركة النقل.',
            ],
          },
          {
            title: 'سابعاً: حدود مسؤولية التطبيق',
            items: [
              'يبذل التطبيق جهدًا معقولًا لضمان عمل الخدمة بشكل صحيح.',
              'لا يضمن التطبيق عدم حدوث أعطال تقنية أو انقطاع مؤقت للخدمة.',
              'الحد الأقصى لمسؤولية التطبيق – إن وجدت – لا يتجاوز قيمة رسوم الحجز المدفوعة عبر التطبيق فقط.',
            ],
          },
          {
            title: 'ثامناً: حساب المستخدم',
            items: [
              'المستخدم مسؤول عن حماية رقم هاتفه ورمز التحقق المرسل إليه.',
              'يحق للتطبيق إيقاف أو حذف أي حساب يستخدم بطريقة مخالفة أو احتيالية.',
              'يمنع استخدام التطبيق لأي نشاط غير قانوني أو ضار.',
            ],
          },
        ].map((section) => (
          <div key={section.title}>
            <h3 className="font-bold text-blue-800 text-sm mb-2 border-b border-blue-100 pb-1">{section.title}</h3>
            <ul className="space-y-1.5 list-none">
              {section.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-xs text-gray-600">
                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Privacy Policy */}
        <div>
          <h3 className="font-bold text-blue-800 text-sm mb-2 border-b border-blue-100 pb-1">تاسعاً: سياسة الخصوصية</h3>
          <div className="space-y-3 text-xs text-gray-600">
            <div>
              <p className="font-semibold text-gray-700 mb-1">المعلومات التي نجمعها:</p>
              <p>الاسم، رقم الهاتف، البريد الإلكتروني (اختياري)، بيانات الحجز، معلومات الدفع عبر مزودات الدفع المعتمدة.</p>
            </div>
            <div>
              <p className="font-semibold text-gray-700 mb-1">استخدام المعلومات:</p>
              <p>تنفيذ الحجوزات، التواصل مع المستخدم، تحسين الخدمة، إرسال الإشعارات المتعلقة بالحجوزات.</p>
            </div>
            <div>
              <p className="font-semibold text-gray-700 mb-1">مشاركة المعلومات:</p>
              <p>قد تتم مشاركة بعض البيانات الضرورية مع شركات الباصات، مزودي خدمات الدفع، والجهات الرسمية عند الطلب القانوني.</p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-bold text-blue-800 text-sm mb-2 border-b border-blue-100 pb-1">عاشراً: القانون المعمول به</h3>
          <p className="text-xs text-gray-600">تخضع هذه الشروط للقوانين المعمول بها في جمهورية السودان، وتكون المحاكم المختصة داخل السودان هي الجهة المختصة بالنظر في أي نزاع.</p>
        </div>

        <div>
          <h3 className="font-bold text-blue-800 text-sm mb-2 border-b border-blue-100 pb-1">التواصل</h3>
          <div className="text-xs text-gray-600 space-y-1">
            <p>📧 البريد الإلكتروني: support@saferbus.com</p>
            <p>📱 رقم الهاتف: 0912 345 678</p>
            <p>🌐 الموقع: www.saferbus.com</p>
          </div>
        </div>

        {/* Final disclaimer box */}
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 text-xs text-blue-800">
          <p className="font-bold mb-1">إقرار المستخدم</p>
          <p>بالضغط على زر <strong>"أوافق وأنشئ حسابي"</strong> فإن المستخدم يقر بأنه قرأ وفهم ووافق على جميع شروط الخدمة وسياسة الخصوصية وإخلاء المسؤولية المذكورة أعلاه.</p>
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0">
        <button onClick={onClose}
          className="w-full bg-blue-700 hover:bg-blue-800 text-white font-semibold py-2.5 rounded-xl transition-colors text-sm">
          فهمت وأغلق
        </button>
      </div>
    </div>
  </div>
);

export default TermsModal;
